import { IItemList } from "@/components/core/Select";

export const SORT_OPTIONS: IItemList[] = [
  {
    label: "Subscribers",
    value: "subscribers"
  },
  {
    label: "Posts",
    value: "posts"
  },
  {
    label: "Name: A-Z",
    value: "alphabetical_asc"
  },
  {
    label: "Name: Z-A",
    value: "alphabetical_desc"
  },
];
